import { cryptoInstance } from '@/public/fetch/index';
import { orderApi2 } from '@/public/utils/basePath';
const baseURL = orderApi2;
// 兑换-兑换码列表
export const codeSearch = (params) => {
    return cryptoInstance.get('/client/exchange/code/search', {
        baseURL,
        params
    });
};
// 兑换-认领
export const exchangeClaim = (params) => {
    return cryptoInstance.post('/client/exchange/claim', params, {
        baseURL
    });
};
// 兑换-认领初始化
export const claimInit = () => {
    return cryptoInstance.get('/client/exchange/claim/init', {
        baseURL,
    });
};
// 兑换-课程搜索
export const courseSearch = (params) => {
    return cryptoInstance.get('/client/exchange/course/search', {
        baseURL,
        params
    });
};
// 兑换
export const exchangeMake = (params) => {
    return cryptoInstance.post('/client/exchange/make', params, {
        baseURL
    });
};
// 兑换-结果
export const exchangeResult = (params) => {
    return cryptoInstance.get('/client/exchange/result', {
        baseURL,
        params
    });
};
